module.exports = __webpack_public_path__ + "static/media/automobile.a6fcaf0b.png";